import React, { useContext, useEffect, useState } from "react"
import Context from "../utils/Context"
import { cancelActions, sendJourney, sendTaskToRobot } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStopCircle } from "@fortawesome/free-solid-svg-icons"
import api from "../api/api"

export default function ModalVerification() {
    const context = useContext(Context)

    const [maxWeight, setMaxWeight] = useState(0)
    const [maxHeight, setMaxHeight] = useState(0)

    useEffect(() => {
        api.fetchRacks()
            .then((res) => {
                const index = racks?.find(r => r.pointName === context.lastDrop.point)?.levels.findIndex(l => l === context.lastDrop.height)
                const racks = res.data

                setMaxHeight(parseFloat(racks?.find(r => r.pointName === context.lastDrop.point)?.maxHeights[index]) - 0.2)
                setMaxWeight(racks?.find(r => r.pointName === context.lastDrop.point)?.maxWeight)
            })
    }, [])

    const cancelAll = () => {
        cancelActions({ stopAll: true }, context.selectedRobot.ROS)
        context.actions.setCurrentMission(null)

        if (context.currentTask === 'weigh') {
            var weighRetreat = {
                "name": "Weigh Retreat",
                "actions": [
                    {
                        "id": "fork",
                        "name": "fork",
                        "needsValue": true,
                        "value": (context.forkHeight - 0.15).toString()
                    },
                    {
                        "id": "undock-pallet",
                        "name": "undock-pallet",
                        "needsValue": false
                    },
                    {
                        "id": "fork",
                        "name": "fork",
                        "needsValue": true,
                        "value": "0.0"
                    },
                ]
            }

            sendTaskToRobot({ actions: weighRetreat.actions, name: weighRetreat.name, id: weighRetreat.name })
        }
        context.actions.setModalState({ ...context.modalState, verification: false })
    }

    return (
        <div className="modal is-active">
            <div className="modal-background"></div>

            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <header className="modal-card-head">
                    <p className="modal-card-title">Verificação de {context.currentTask === 'weigh' ? 'Peso ' : 'Altura '}</p>
                </header>

                <section className="modal-card-body">
                    <div className="field mb-5">
                        <div className="controls">
                            <div className="control mb-3">
                                <p>
                                    A rack de destino tem {context.currentTask === 'weigh' ? ('um peso limite de ' + maxWeight + 'kg ') : ('uma altura máxima de ' + maxHeight + 'm ')}e a palete não está conforme.
                                </p>
                            </div>

                            <div className="control mb-3">
                                <p>
                                    Terá que cancelar tudo para enviar novas missões.
                                    {context.currentTask === 'weigh' ? ' O robô terá ainda que pousar esta palete e recuar antes de proceder à operação.' : ''}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <footer className="modal-card-foot">
                    <button className="button is-danger" onClick={cancelAll}>
                        <FontAwesomeIcon icon={faStopCircle} className="is-small mr-1" />
                        Cancelar Tudo
                    </button>
                </footer>
            </div>
        </div>
    )
}